import { HttpClient } from '../HttpClient';
/**
 * * Get Total Outstanding Balance
 **/

export const GetTotalOutstandingBalance = async () => {
  try {
    const response = await HttpClient.get(
      `/api/v1/loans/totalOutstandingBalance`
    );
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const GetTotalOutstandingBalanceBreakdown = async () => {
  try {
    const response = await HttpClient.get(
      `/api/v1/loans/totalOutstandingBalance/breakdown`
    );
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
}